<template>
  <div class="card card-custom gutter-b" v-loading="loading">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Danh sách yêu cầu</h3>
      </div>
      <div class="card-title">
        <button
          type="button"
          class="btn btn-light-primary font-weight-bolder mr-2"
          :disabled="is_disable_export"
          @click="handleExport"
        >
          <span class="svg-icon svg-icon-md"><i class="el-icon-download"></i></span> Export
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row filter_form">
        <div class="col-md-3">
          <div class="form-group">
            <el-select
              v-model="queryFilter.type"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn loại yêu cầu"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in requestTypeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3" v-if="queryFilter.type === requestTypeDepartment">
          <div class="form-group">
            <el-select
              v-model="queryFilter.department"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn phòng ban"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in departments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3" v-if="queryFilter.type === requestTypeFacility">
          <div class="form-group">
            <el-select
              v-model="queryFilter.center"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn trung tâm"
              @change="queryFilterByCenter"
              collapse-tags
            >
              <el-option
                v-for="item in centers"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3" v-if="queryFilter.type === requestTypeFacility && queryFilter.center">
          <div class="form-group">
            <el-select
              v-model="queryFilter.branch"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn chi nhánh"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in branches"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <el-select
              v-model="queryFilter.typeDetails"
              class="w-100"
              multiple
              filterable
              clearable
              collapse-tags
              placeholder="Chọn phân loại chi tiết"
              @change="handleChangeFilter"
            >
              <el-option
                v-for="item in productTypeDetailOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <el-date-picker
              v-model="queryFilter.createdAt"
              class="w-100"
              type="daterange"
              align="right"
              start-placeholder="Thời gian bắt đầu"
              end-placeholder="Thời gian kết thúc"
              format="dd-MM-yyyy"
              value-format="yyyy-MM-dd"
              :default-value="new Date()"
              @change="handleChangeFilter"
            />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <el-select
              v-model="queryFilter.personInCharge"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn người phụ trách"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in listPersonInChargeOption"
                :key="item.id"
                :label="(item.id + 100000) + ' - ' + item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <el-select
              v-model="queryFilter.status"
              class="w-100"
              filterable
              clearable
              placeholder="Chọn trạng thái"
              @change="handleChangeFilter"
              collapse-tags
            >
              <el-option
                v-for="item in LOGISTICS_STATUSES"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
      </div>

      <div
        v-if="requestSelectedList.length > 0"
        class="d-flex align-items-center my-4"
      >
        <div class="d-flex align-items-center flex-wrap">
          <span class="mr-4 mb-2 mb-md-0">Đã chọn ({{ requestSelectedList.length }})</span>
          <button
            class="btn btn-primary font-weight-bold mr-2 mb-2 mb-md-0"
            :disabled="submittingWorkCoordination || submittingChangeStatus || requestSelectedList.length === 0"
            @click="handleWorkCoordination"
          >
            <i :class="submittingWorkCoordination ? 'fas fa-spinner fa-spin mr-1' : 'fa fa-random mr-1'"></i>
            {{ submittingWorkCoordination ? "Đang điều phối..." : "Điều phối công việc" }}
          </button>
          <button
            class="btn btn-info font-weight-bold mr-2 mb-2 mb-md-0"
            :disabled="submittingChangeStatus || requestSelectedList.length === 0"
            @click="handleChangeStatuses"
          >
            <i :class="submittingChangeStatus ? 'fas fa-spinner fa-spin mr-1' : 'fas fa-exchange-alt mr-1'"></i>
            {{ submittingChangeStatus ? "Đang cập nhật..." : "Thay đổi trạng thái" }}
          </button>
          <button
            class="btn btn-secondary font-weight-bold mb-2 mb-md-0"
            :disabled="submittingWorkCoordination || submittingChangeStatus"
            @click="cancelSelected"
          >
            <i class="el-icon-close mr-1"></i> Hủy
          </button>
        </div>
      </div>

      <div class="table-responsive mt-4">
        <table class="table table-bordered table-vertical-center mb-0">
          <thead class="bg-light">
            <tr>
              <th class="text-left align-middle request-checkbox-cell">
                <el-checkbox
                  v-model="isSelectedAll"
                  :disabled="disableSelectedAll"
                  @change="selectedAllRequest"
                />
              </th>
              <th class="text-left align-middle request-checkbox-cell">Mã</th>
              <th class="text-left align-middle">Tên</th>
              <th class="text-left align-middle text-nowrap">Loại</th>
              <th class="text-left align-middle text-nowrap request-type-detail-cell">Phân loại chi tiết</th>
              <th class="text-left align-middle">Người yêu cầu</th>
              <th class="text-left align-middle">Người phụ trách</th>
              <th class="text-left align-middle text-nowrap">Thời gian yêu cầu</th>
              <th class="text-left align-middle">Phòng ban / Cơ sở yêu cầu</th>
              <th class="text-left align-middle">Trạng thái</th>
              <th class="text-left align-middle">Hành động</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="requestList?.length > 0">
              <tr v-for="(item, index) of requestList" :key="item?.id">
                <td class="text-left align-middle">
                  <el-checkbox
                    v-model="item.selected"
                    :disabled="!canCoordinateRequest(item)"
                    @change="getRequestSelectedList"
                  />
                </td>
                <td class="text-left align-middle">{{ item.code }}</td>
                <td class="text-left align-middle">{{ item.name }}</td>
                <td class="text-left align-middle">
                  <span
                    class="px-2 py-1 rounded-pill text-nowrap request-type-badge"
                    :class="getTypeClass(item.type)"
                  >
                    {{ item.type }}
                  </span>
                </td>
                <td class="text-left align-middle request-type-detail-cell">
                  <el-tooltip
                    :content="item.type_detail"
                    placement="top"
                    :disabled="!item.type_detail"
                  >
                    <span class="request-type-detail-text">{{ item.type_detail }}</span>
                  </el-tooltip>
                </td>
                <td class="text-left align-middle">
                  <p class="line-clamp-1 mb-0 text-break">
                    {{ item.requester_name }}
                  </p>
                </td>
                <td class="text-left align-middle">{{ item.person_in_charge }}</td>
                <td class="text-left align-middle">{{ item.request_time }}</td>
                <td class="text-left align-middle">
                  {{ getRequestLocation(item) }}
                </td>
                <td class="text-left align-middle">
                  <span
                    class="request-status-badge"
                    :class="getStatusClass(item.status)"
                  >
                    {{ item.status }}
                  </span>
                </td>
                <td class="text-left align-middle">
                  <router-link
                    :to="{ name: 'logisticsRequestDetail', params: { id: item.id } }"
                    class="btn btn-icon btn-xs btn-outline-info"
                  >
                    <i class="fas far fa-eye"></i>
                  </router-link>
                  <button
                    v-if="item.status !== 'Hoàn thành' && item.status !== 'Hủy'"
                    class="btn btn-icon btn-xs btn-outline-danger ml-2"
                    :disabled="deletingRequestId === item.id || !canCancelRequest(item)"
                    @click="onDeleteRequest(item)"
                  >
                    <i :class="deletingRequestId === item.id ? 'fas fa-spinner fa-spin' : 'el-icon-delete'"></i>
                  </button>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="11" class="text-center">Chưa có dữ liệu</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="requestList?.length > 0">
          <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
            <paginate
              v-model="page"
              :page-count="lastPage"
              :page-range="3"
              :margin-pages="1"
              :click-handler="clickCallback"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
            />
          </div>
          <div class="d-flex justify-content-end">
            <div>
              Tổng số bản ghi:
              <span class="ml-1 text-primary font-weight-bold">
                {{ this.total ?? requestList.length }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Điều phối công việc"
      :show-close="false"
      :visible.sync="isWorkCoordination"
      @getRequestList="getRequestList"
      v-if="isWorkCoordination"
    >
      <hr class="mt-n3" />
      <DialogWorkCoordination
        @closeDialog="isWorkCoordination = false"
        :list-request-selected="requestSelectedList"
        :submit-loading="submittingWorkCoordination"
        @submitWorkCoordination="submitWorkCoordination"
        @workCoordinationSuccess="workCoordinationSuccess"
        @getRequestList="getRequestList"
      />
    </el-dialog>

    <el-dialog
      title="Thay đổi trạng thái"
      :show-close="false"
      :visible.sync="isChangeStatus"
      v-if="isChangeStatus"
    >
      <DialogChangeLogisticsStatus
        :selected-count="requestSelectedList.length"
        :submit-loading="submittingChangeStatus"
        @close="isChangeStatus = false"
        @submit="submitChangeStatuses"
      />
    </el-dialog>

    <DialogExportLogistics
      :visible.sync="exportDialogVisible"
      :loading="exportLoading"
      @confirm="confirmExport"
    />
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  DELETE_LOGISTICS_REQUEST,
  GET_LOGISTICS_REQUESTS,
  WORK_COORDINATION,
  GET_DEPARTMENT_IN_CHARGE,
  EXPORT_LOGISTICS_TICKETS,
  CHANGE_LOGISTICS_STATUS_MULTIPLE,
} from "@/core/services/store/logistics/logistics.module";
import {
  LOGISTICS_STATUSES,
  PRODUCT_TYPE_OPTIONS,
  PRODUCT_TYPE_DETAIL_OPTIONS,
} from "@/core/option/logisticsOption";
import { exportExcel } from "@/core/filters";
import { GET_DEPARTMENTS } from "@/core/services/store/ticket/ticket.module";
import {
  GET_CENTER_TAG_E,
  GET_BRANCHES,
} from "@/core/services/store/task-management/task-management.module";
import { mapGetters } from "vuex";
import DialogWorkCoordination from "@/view/pages/logistics/components/DialogWorkCoordination.vue";
import DialogExportLogistics from "@/view/pages/logistics/components/DialogExportLogistics.vue";
import DialogChangeLogisticsStatus from "@/view/pages/logistics/components/DialogChangeLogisticsStatus.vue";

const HEADER_ROW_EXPORT_LOGISTICS = [
  { key: "stt", value: "STT" },
  { key: "type", value: "Loại" },
  { key: "type_detail", value: "Phân loại chi tiết" },
  { key: "department_name", value: "Phòng ban/cơ sở" },
  { key: "name_product", value: "Tên sản phẩm" },
  { key: "quantity", value: "Số lượng" },
  { key: "ticket_status", value: "Trạng thái" },
  { key: "day_order", value: "Ngày tạo" },
];

const EXPORT_LOGISTICS_FILE_NAME = "Danh sách sản phẩm order chưa xử lý.xlsx";

export default {
  name: "RequestList",
  components: {
    DialogWorkCoordination,
    DialogExportLogistics,
    DialogChangeLogisticsStatus,
  },
  data() {
    return {
      loading: true,
      page: 1,
      lastPage: 1,
      total: 0,
      requestList: [],
      isSelectedAll: false,
      requestSelectedList: [],
      disableSelectedAll: false,
      departments: [],
      centers: [],
      branches: [],
      listPersonInChargeOption: [],
      LOGISTICS_STATUSES,
      requestTypeOptions: PRODUCT_TYPE_OPTIONS.filter((item) => item.id !== 2),
      productTypeDetailOptions: PRODUCT_TYPE_DETAIL_OPTIONS,
      requestTypeDepartment: PRODUCT_TYPE_OPTIONS[0]?.id ?? 0,
      requestTypeFacility: PRODUCT_TYPE_OPTIONS[1]?.id ?? 1,
      submittingWorkCoordination: false,
      submittingChangeStatus: false,
      deletingRequestId: null,
      isWorkCoordination: false,
      isChangeStatus: false,
      is_disable_export: false,
      exportDialogVisible: false,
      exportLoading: false,
      queryFilter: {
        type: null,
        department: null,
        center: null,
        branch: null,
        createdAt: [],
        personInCharge: null,
        status: null,
        typeDetails: [],
      },
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Logistics", route: "" },
      { title: "Danh sách yêu cầu" },
    ]);
    this.getRequestList();
    this.getAllPersonInCharge();
    this.getDepartments();
    this.getCenters();
  },
  methods: {
    handleExport() {
      this.exportDialogVisible = true;
    },
    async confirmExport({ type_details: typeDetails }) {
      this.is_disable_export = true;
      this.exportLoading = true;
      try {
        const res = await this.$store.dispatch(EXPORT_LOGISTICS_TICKETS, {
          type_details: typeDetails,
        });
        if (res.error) {
          this.$message.error(res.message || "Không thể xuất được dữ liệu");
          return;
        }
        const dataExport = res.data ?? [];
        exportExcel(
          HEADER_ROW_EXPORT_LOGISTICS,
          dataExport,
          EXPORT_LOGISTICS_FILE_NAME,
          true
        );
        this.$message.success("Xuất dữ liệu thành công");
        this.exportDialogVisible = false;
      } catch (error) {
        console.error("Export error:", error);
        this.$message.error(error?.message || "Không thể xuất được dữ liệu");
      } finally {
        this.is_disable_export = false;
        this.exportLoading = false;
      }
    },
    getStatusClass(status) {
      const statusClasses = {
        "Chưa tiếp nhận": "bg-gray",
        "Đang xử lý": "bg-yellow",
        "Đã cung cấp đủ hàng": "bg-blue",
        "Đã nhận hàng": "bg-teal",
        "Hoàn thành": "bg-green",
        Hủy: "bg-danger-soft",
      };
      return statusClasses[status] || "bg-gray";
    },
    getTypeClass(type) {
      const typeClasses = {
        "Trụ sở": "bg-blue text-white",
        "Cơ sở": "bg-green text-white"
      };
      return typeClasses[type] || "bg-gray text-white";
    },
    getRequestLocation(item) {
      if (item.type === "Trụ sở") {
        return item.department_name;
      }
      if (item.type === "Cơ sở") {
        return item.facility_name;
      }
      return item.department_name || item.facility_name || "";
    },
    canCoordinateRequest(item) {
      return !["Hoàn thành", "Hủy"].includes(item?.status);
    },
    canCancelRequest(item) {
      return !["Hoàn thành", "Hủy"].includes(item?.status);
    },
    selectedAllRequest() {
      if (this.isSelectedAll) {
        this.requestList.forEach((item) => {
          item.selected = this.canCoordinateRequest(item);
        });
        this.requestSelectedList = this.requestList.filter((item) => item.selected);
      } else {
        this.requestList.forEach((item) => (item.selected = false));
        this.requestSelectedList = [];
      }
    },
    getRequestSelectedList() {
      this.requestSelectedList = this.requestList.filter(
        (item) => item.selected && this.canCoordinateRequest(item)
      );
      this.isSelectedAll =
        this.requestList.some((item) => this.canCoordinateRequest(item)) &&
        this.requestList
          .filter((item) => this.canCoordinateRequest(item))
          .every((item) => item.selected);
    },
    cancelSelected() {
      this.requestList.forEach((item) => (item.selected = false));
      this.requestSelectedList = [];
      this.isSelectedAll = false;
    },
    handleWorkCoordination() {
      if (this.requestSelectedList.length === 0) {
        this.$message({
          message: "Vui lòng chọn ít nhất một yêu cầu",
          type: "warning",
        });
        return;
      }
      this.isWorkCoordination = true;
    },
    handleChangeStatuses() {
      if (this.requestSelectedList.length === 0) {
        this.$message.warning("Vui lòng chọn ít nhất một yêu cầu");
        return;
      }
      this.isChangeStatus = true;
    },
    submitChangeStatuses(status) {
      this.submittingChangeStatus = true;
      this.$store.dispatch(CHANGE_LOGISTICS_STATUS_MULTIPLE, {
        ids: this.requestSelectedList.map((item) => item.id),
        status,
      }).then((res) => {
        if (!res.error) {
          this.$message.success("Cập nhật trạng thái yêu cầu thành công");
          this.isChangeStatus = false;
          this.cancelSelected();
          this.getRequestList();
        } else {
          this.$message.error(res.message || "Cập nhật trạng thái yêu cầu thất bại");
        }
      }).catch((e) => {
        this.$message.error(e?.message || "Cập nhật trạng thái yêu cầu thất bại");
      }).finally(() => {
        this.submittingChangeStatus = false;
      });
    },
    workCoordinationSuccess() {
      this.cancelSelected();
    },
    submitWorkCoordination(payload) {
      this.submittingWorkCoordination = true;
      this.$store.dispatch(WORK_COORDINATION, payload).then((res) => {
        if (!res.error) {
          this.$message.success("Điều phối công việc thành công");
          this.getRequestList();
          this.workCoordinationSuccess();
          this.isWorkCoordination = false;
        } else {
          this.$message.error(res.message || "Điều phối công việc thất bại");
        }
      }).catch((e) => {
        console.log(e, "Error work coordination");
        this.$message.error(e?.message || "Điều phối công việc thất bại");
      }).finally(() => {
        this.submittingWorkCoordination = false;
      });
    },
    async onDeleteRequest(item) {
      if (this.deletingRequestId || !this.canCancelRequest(item)) return;
      try {
        await this.$confirm(
          `Bạn có chắc chắn muốn hủy yêu cầu "${item.name || item.id}" không?`,
          "Xác nhận hủy yêu cầu",
          {
            confirmButtonText: "Hủy yêu cầu",
            cancelButtonText: "Đóng",
            type: "warning",
          }
        );
        this.deletingRequestId = item.id;
        const res = await this.$store.dispatch(DELETE_LOGISTICS_REQUEST, {
          id: item.id,
        });
        if (!res.error) {
          this.$message.success("Hủy yêu cầu thành công");
          this.getRequestList();
        } else {
          this.$message.error(res.message || "Hủy yêu cầu thất bại");
        }
      } catch (e) {
        if (e !== "cancel") {
          console.log(e, "error cancel request");
          this.$message.error(e?.message || "Hủy yêu cầu thất bại");
        }
      } finally {
        this.deletingRequestId = null;
      }
    },
    getAllPersonInCharge() {
      const payload = { is_all: 1 };
      this.$store
        .dispatch(GET_DEPARTMENT_IN_CHARGE, payload)
        .then((res) => {
          if (!res.error) {
            this.listPersonInChargeOption = res.data ?? [];
          }
        })
        .catch((e) => {
          console.log(e, "Error get list personInCharge");
        });
    },
    getDepartments() {
      const payload = { limit: 10000 };
      this.$store
        .dispatch(GET_DEPARTMENTS, payload)
        .then((res) => {
          if (!res.error) {
            this.departments = res.data ?? [];
          }
        })
        .catch((e) => {
          console.log(e, "Error get departments");
        });
    },
    getCenters() {
      const payload = {
        limit: 10000,
        is_edutalk: 1,
        status: 1,
      };
      this.$store
        .dispatch(GET_CENTER_TAG_E, payload)
        .then((res) => {
          if (!res.error) {
            this.centers = res.data?.data ?? [];
          }
        })
        .catch((e) => {
          console.log(e, "Error get centers");
        });
    },
    getBranches(centerId) {
      const payload = {
        limit: 10000,
        center_id: centerId,
      };
      this.$store
        .dispatch(GET_BRANCHES, payload)
        .then((res) => {
          if (!res.error) {
            this.branches = res.data?.data ?? [];
          }
        })
        .catch((e) => {
          console.log(e, "Error get branches");
        });
    },
    async queryFilterByCenter() {
      this.page = 1;
      this.queryFilter.branch = null;
      if (this.queryFilter.center) {
        this.getBranches(this.queryFilter.center);
      }
      await this.getRequestList();
    },
    async handleChangeFilter() {
      this.page = 1;
      if (this.queryFilter.type !== this.requestTypeDepartment) {
        this.queryFilter.department = null;
      }
      if (this.queryFilter.type !== this.requestTypeFacility) {
        this.queryFilter.center = null;
        this.queryFilter.branch = null;
        this.branches = [];
      }
      await this.getRequestList();
    },
    clickCallback(obj) {
      this.page = obj;
      this.getRequestList();
    },
    async getRequestList() {
      this.loading = true;
      const payload = {
        page: this.page,
        limit: 20,
        type: this.queryFilter.type,
        department_id: this.queryFilter.department,
        center_id: this.queryFilter.center,
        branch_id: this.queryFilter.branch,
        person_in_charge_id: this.queryFilter.personInCharge,
        date_range_created: this.queryFilter.createdAt,
        status: this.queryFilter.status,
        type_details: this.queryFilter.typeDetails,
      };

      this.$store
        .dispatch(GET_LOGISTICS_REQUESTS, payload)
        .then((res) => {
          if (!res.error) {
            this.page = res.pagination.current_page;
            this.lastPage = res.pagination.last_page;
            this.total = res.pagination.total;
            this.requestList =
              (res.data || []).map((item) => ({
                ...item,
                selected: false,
              })) ?? [];
            this.disableSelectedAll = !this.requestList.some((item) => this.canCoordinateRequest(item));
            this.isSelectedAll = false;
            this.requestSelectedList = [];
          }
        })
        .catch((e) => {
          console.log(e, "Error get request list");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>

<style scoped>
.mx-datepicker-popup {
  z-index: 9999999 !important;
}

.bg-blue {
  background: #0066ff;
}

.bg-green {
  background: #038200;
}

.bg-purple {
  background: #7239ea;
}

.request-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
}

.bg-yellow {
  background: #fff3cd;
  color: #8a5a00;
  border-color: #ffe08a;
}

.bg-gray {
  background: #eef1f5;
  color: #5f6b7a;
  border-color: #d7dee7;
}

.bg-teal {
  background: #e6fffb;
  color: #0f8b82;
  border-color: #9be7df;
}

.bg-danger-soft {
  background: #fdecec;
  color: #d14343;
  border-color: #f6bcbc;
}

.request-status-badge.bg-blue {
  background: #e8f1ff;
  color: #0b63f6;
  border-color: #b8d2ff;
}

.request-status-badge.bg-green {
  background: #e9f9ee;
  color: #14833b;
  border-color: #b7e4c7;
}

.request-checkbox-cell {
  width: 40px;
}

.request-type-badge {
  word-break: break-word;
}

.request-type-detail-cell {
  width: 220px;
  max-width: 220px;
}

.request-type-detail-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter_form {
  margin-top: 4px;
}

.filter_form .form-group {
  margin-bottom: 16px;
}

@media screen and (max-width: 767px) {
  .filter_form .form-group {
    margin-bottom: 12px;
  }
}
</style>
